const getFEURL = () => {
  if (window.location.href.indexOf("capacitor") != -1) {
    return process.env.REACT_APP_CAPACITOR_FE_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port === "8100"
  ) {
    return process.env.REACT_APP_FE_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port !== "8100"
  ) {
    return process.env.REACT_APP_CAPACITOR_FE_URL;
  } else if (
    window.location.href.indexOf("dev") != -1 &&
    window.location.href.includes("test1") &&
    window.location.href.includes("usc1")
  ) {
    return process.env.REACT_APP_FE_URL_DEV_TEST1_USC;
  } else if (window.location.href.indexOf("dev") != -1) {
    return process.env.REACT_APP_FE_URL_DEV;
  } else if (window.location.href.indexOf("qa") != -1) {
    return process.env.REACT_APP_FE_URL_QA;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile1.uat")
  ) {
    return process.env.REACT_APP_FE_URL_NR_2;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile.uat")
  ) {
    return process.env.REACT_APP_FE_URL_NR;
  } else {
    return process.env.REACT_APP_FE_URL_PROD;
  }
};

const getBEURL = () => {
  if (window.location.href.indexOf("capacitor") != -1) {
    return process.env.REACT_APP_CAPACITOR_BE_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port === "8100"
  ) {
    return process.env.REACT_APP_BE_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port !== "8100"
  ) {
    return process.env.REACT_APP_CAPACITOR_BE_URL;
  } else if (
    window.location.href.indexOf("dev") != -1 &&
    window.location.href.includes("test1") &&
    window.location.href.includes("usc1")
  ) {
    return process.env.REACT_APP_BE_URL_DEV_TEST1_USC;
  } else if (window.location.href.indexOf("dev") != -1) {
    return process.env.REACT_APP_BE_URL_DEV;
  } else if (window.location.href.indexOf("qa") != -1) {
    return process.env.REACT_APP_BE_URL_QA;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile1.uat")
  ) {
    return process.env.REACT_APP_BE_URL_NR_2;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile.uat")
  ) {
    return process.env.REACT_APP_BE_URL_NR;
  } else {
    return process.env.REACT_APP_BE_URL_PROD;
  }
};

const getDesktopRedirectURL = () => {
  if (window.location.href.indexOf("localhost") != -1) {
    return process.env.REACT_APP_REDIRECT_URI;
  } else if (
    window.location.href.indexOf("dev") != -1 &&
    window.location.href.includes("test1") &&
    window.location.href.includes("usc1")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_DEV_TEST1_USC;
  } else if (window.location.href.indexOf("dev") != -1) {
    return process.env.REACT_APP_REDIRECT_URI_DEV;
  } else if (window.location.href.indexOf("qa") != -1) {
    return process.env.REACT_APP_REDIRECT_URI_QA;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile1.uat")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_NR_2;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile.uat")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_NR;
  } else {
    return process.env.REACT_APP_REDIRECT_URI_PROD;
  }
};

const getMobileRedirectUri = () => {
  if (window.location.href.indexOf("capacitor") != -1) {
    return process.env.REACT_APP_CAPACITOR_REDIRECT_URI;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port === "8100"
  ) {
    return process.env.REACT_APP_REDIRECT_URI;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port !== "8100"
  ) {
    return process.env.REACT_APP_CAPACITOR_REDIRECT_URI;
  } else if (
    window.location.href.indexOf("dev") != -1 &&
    window.location.href.includes("test1") &&
    window.location.href.includes("usc1")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_DEV_TEST1_USC;
  } else if (window.location.href.indexOf("dev") != -1) {
    return process.env.REACT_APP_REDIRECT_URI_DEV;
  } else if (window.location.href.indexOf("qa") != -1) {
    return process.env.REACT_APP_REDIRECT_URI_QA;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile1.uat")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_NR_2;
  } else if (
    window.location.href.indexOf("uat") != -1 &&
    window.location.href.includes("cmedmobile.uat")
  ) {
    return process.env.REACT_APP_REDIRECT_URI_NR;
  } else {
    return process.env.REACT_APP_REDIRECT_URI_PROD;
  }
};

const getLogoutUrl = () => {
  if (window.location.href.indexOf("capacitor") != -1) {
    return process.env.REACT_APP_CAPACITOR_LOGOUT_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port === "8100"
  ) {
    return process.env.REACT_APP_LOGOUT_URL;
  } else if (
    window.location.href.indexOf("localhost") != -1 &&
    window.location.port !== "8100"
  ) {
    return process.env.REACT_APP_CAPACITOR_LOGOUT_URL;
  } else if (
    window.location.href.indexOf("dev") != -1 &&
    window.location.href.includes("test1") &&
    window.location.href.includes("usc1")
  ) {
    return process.env.REACT_APP_LOGOUT_URL_DEV_TEST1_USC;
  } else if (window.location.href.indexOf("dev") != -1) {
    return process.env.REACT_APP_LOGOUT_URL_DEV;
  } else if (window.location.href.indexOf("qa") != -1) {
    return process.env.REACT_APP_LOGOUT_URL_QA;
  } else if (window.location.href.indexOf("uat") != -1) {
    return process.env.REACT_APP_LOGOUT_URL_NR;
  } else {
    return process.env.REACT_APP_LOGOUT_URL_PROD;
  }
};
export const DESKTOP_REDIRECT_URL = getDesktopRedirectURL();
export const FE_URL = getFEURL();
export const BE_URL = getBEURL();
export const MOBILE_REDIRECT_URI = getMobileRedirectUri();
export const LOGOUT_URL = getLogoutUrl();
